// JS libraries included in plugins.min.js
jQuery(window).setBreakPoints([360,540,768,1024,1200,1320,1560]);

// Detects Touch Event
window.addEventListener('touchstart',function onFirstTouch(){
	document.documentElement.className += " touch";
	window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

// Global Variables - Google Tag Manager
window.dataLayer = window.dataLayer || [];

// Global Variables - WordPress Theme information
var DOMAIN = location.protocol + "//" + location.host;

// Global Variables - Page/Viewport Heights
var pageHeight;
var viewHeight;
var menuHeight;	
	
// Global Variables - Vimeo Player for Modal
var vimeoModalPlayer;

// jQuery Document Ready
var $ = jQuery;
jQuery(document).ready(function($){
	
	// Sets Element Height Values
	pageHeight = $('body').outerHeight();
	viewHeight = vhCheck().vh;
	menuHeight = $('header .container').outerHeight();	

	// Global Components	
	initScrollMagic();
	initTopNav();
	initScrollMenu();
	initVideoModal();
	initSlider();
	intitDownload();
	
	// Page Specific Components	
	// if (isPage('home')){ }

});


// =====================================================================
// Gallery File Download
// =====================================================================
function intitDownload(){

	$('.gallery .download button').click(function(event){	
		event.preventDefault();
		var downloadFile = $(this).data('file');
		var downloadFolder = $(this).closest('article').data('year');
		location.href = "download-image.php?file="+downloadFile+"&folder="+downloadFolder;
	});

}

// =====================================================================
// Timeline Slideshows
// =====================================================================
function initSlider(){
	var slideCount = $('#memories #timelineView article').length - 1;
	var video = [];
	var gallery = [];

	// Populates array AFTER view screen is initialized
	$('#timelineView').on('init', function(event, slick){
		$('#timelineView article').each(function(){ 
			var slideIndex = $(this).data('slick-index');
			// Array of indexes that have a gallery
			if ($('.gallery',this).length){
				gallery[slideIndex] = $('.gallery',this);
			}
			// Array of indexes that have a video
			if ($('.video',this).length){
				video[slideIndex] = new Vimeo.Player($('iframe',this));
			}
		});
	});
	// Populates array AFTER each inner gallery is initialized
	$('#timelineView .gallery').on('init', function(event, slick){
		$(this).closest('article').find('.galleryCount span:last-of-type').text($('.slick-slide',this).length);
	});

	// Setup Dual Sliders	 
	$('#timelineView').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		accessibility: false,
		draggable: false,
		swipe: false,
		touchMove: false,
		arrows: false,
		infinite: false,
		fade: true,
		initialSlide: slideCount
	 });
	$('#timeline').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		edgeFriction: 0.25,
		asNavFor: '#timelineView',
		swipeToSlide: true,
		accessibility: false,
		dots: false,
		arrows: false,
		centerMode: true,
		focusOnSelect: true,
		infinite: false,
		initialSlide: slideCount,
	 });
	 // Hack - Shrinks mobile timeline
	 if ($(window).getBreakPoint() <= 540){
		$('#timeline').slick('slickSetOption', {'slidesToShow':3}, false);
	 }

	 // Creates individual inner gallery sliders
	 gallery.forEach(function(item,index){
		item.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			accessibility: true,
			draggable: true,
			swipe: true,
			touchMove: true,
			fade: true,	
			focusOnSelect: true	 
		 });
	 });

	 // Stops video when a timeline change occurs
	 $('#timeline').on('beforeChange',function(event, slick, currentSlide, nextSlide){
		 //Sets timeline date to active
		 $(this).addClass('active');

		 if (currentSlide != nextSlide){
			var thisView = $("#timelineView article[data-slick-index='" + currentSlide +"']");
			if ($('.video',thisView).length){
				video[currentSlide].pause();
				video[currentSlide].unload();
			}
			// Pushes timeline date to GTM
			var nextDate = $("#timeline div[data-slick-index='" + nextSlide +"']");
			var nextDateText = $('span',nextDate).text();
			pushGAEventLP('MediaSummit','TimelineView',nextDateText);
		 }
	 });
	 // Stops video when a gallery change occurs
	 $('#timelineView article .gallery').on('beforeChange',function(event, slick, currentSlide, nextSlide){
		//Sets the index number of the inner slide
		$(this).closest('article').find('.galleryCount span:first-of-type').text(nextSlide + 1);

		if (currentSlide != nextSlide){
		  var thisView = $(this).closest('article');
		  var thisViewIndex = thisView.data('slick-index');
		  if ($('.video',thisView).length){
				video[thisViewIndex].pause();
				video[thisViewIndex].unload();
			}
			// Pushes viewing image to GTM
			var nextImage = $("figure[data-slick-index='" + nextSlide +"'] img", this).attr('src').replace('images/slideshow/','');
			pushGAEventLP('MediaSummit','GalleryView',nextImage);
		}
	});

	// Pushes video ID to GTM
	if (video.length){
		video.forEach(function(item,index){
			var videoID;
			item.getVideoId().then(function(id) {
				videoID = id;
		  	})
			item.on('play',function(){
				pushGAEventLP('MediaSummit','VimeoPlay',videoID);
		  	});
		});
	}
}

// =====================================================================
// Global - Fixed Main Menu for Desktop and Mobile
// =====================================================================
function initTopNav(){
	
	// Desktop: Mini Nav on Scroll
	var position = $(window).scrollTop(); 
	checkPos();
	
	$(window).scroll(function(){
		position = $(window).scrollTop();
		checkPos();
	});
	
	function checkPos(){
		if (position != 0){
			$('header').addClass('miniNav');		
		} else {
			$('header').removeClass('miniNav');
		}		
	}
	
	// Mobile: Hamburger Menu
	$('header button.hamburger').click(function(){
		// Checks vHeight
		viewHeight = vhCheck().vh;	
		
		if (!$('html').hasClass('mobileNavOpen')){
			// Locks the background window
			lockWindow(function(){
				$('html').addClass('mobileNavOpen');
				$('header button.hamburger').addClass('open');					
			});
		} else {		
			// Unlocks the background window
			unlockWindow(function(){
				$('html').removeClass('mobileNavOpen');
				$('header button.hamburger').removeClass('open');
			});
		}
	});

	// Resize listener to remove Mobile menu if switching to Desktop
	var lastBP = $(window).getBreakPoint();
	$(window).resize(function(){
		// Checks vHeight
		viewHeight = vhCheck().vh;	
			
		if (lastBP != $(window).getBreakPoint() && $(window).getBreakPoint() >= 1024){
			unlockWindow(function(){
				$('html').removeClass('mobileNavOpen');
				$('header .hamburger').removeClass('open');
			});	
		}
		lastBP = $(window).getBreakPoint();
	});
	
}

// =====================================================================
// Global - Scroll Events on the page
// =====================================================================
function initScrollMagic(){
	
	var showIndicators = false;
	
	// Sets HTML Class
	$('html').addClass('scrollmagic');
	
	// ScrollMagic Controllers
	var bottomTrigger = new ScrollMagic.Controller({
		globalSceneOptions: {
			triggerHook: '1'
		}	
	});
	var middleTrigger = new ScrollMagic.Controller({
		globalSceneOptions: {
			triggerHook: '.5'
		}	
	});
	var topTrigger = new ScrollMagic.Controller({
		globalSceneOptions: {
			triggerHook: '0'
		}	
	});	
	
	// Section Fade-up Scenes	
	var layoutSections = [];
	$('main > section').each(function(key,value){
		var sectionName = $(this).attr('id');
		var selector = '#'+sectionName;				
		layoutSections[key] = new ScrollMagic.Scene({
			triggerElement: selector,
			reverse: false
		})
		.setClassToggle(selector,'inView')
		.addTo(bottomTrigger);
		
		if (showIndicators){
			layoutSections[key].addIndicators({name:"fadeUp"});
		}
	});
	
	// Section Fade In Order	
	var gridSections = [];
	$('main .fadeIn').each(function(key,value){
		var sectionName = $(this).attr('id');
		var selector = '#'+sectionName;				
		gridSections[key] = new ScrollMagic.Scene({
			triggerElement: selector,
			reverse: false
		})
		.setClassToggle(selector,'inView')
		.addTo(bottomTrigger);
		
		if (showIndicators){
			gridSections[key].addIndicators({name:"gridIn"});
		}		
	});	

	// Rain Animation	
	var rainSections = [];
	$('main .rain').each(function(key,value){
		var sectionName = $(this).attr('id');
		var selector = '#'+sectionName;				
		rainSections[key] = new ScrollMagic.Scene({
			triggerElement: selector,
			reverse: false
		})
		.setClassToggle(selector,'active')
		//.setTween(selector+' .rain-vector', {y:"30%",ease:Linear.easeNone})
		//.duration('100%')
		.addTo(bottomTrigger);
		
		if (showIndicators){
			rainSections[key].addIndicators({name:"rainIn"});
		}		
	});	

	// Sets duration/offset after all scene have been defined
	updateScenes();

	// Triggers duration/offset update on resize	
	$(window).resize(function(){
		updateScenes();
	});

	// Sets duration/offset, updates after scene created
	function updateScenes(){
		viewHeight = vhCheck().vh;
		menuHeight = $('header .container').outerHeight();
		
		// Section Fade Up
		var fadeOffset = viewHeight * 0.30;
		for (i=0; i<layoutSections.length; i++){
			selector = "#"+layoutSections[i].triggerElement().getAttribute('id');
			layoutSections[i].offset(fadeOffset);
		}

		// Section Fade In Order
		var gridOffset = viewHeight * 0.20;
		for (i=0; i<gridSections.length; i++){
			selector = "#"+gridSections[i].triggerElement().getAttribute('id');
			gridSections[i].offset(gridOffset);
		}

		// Rain Icons
		var rainOffset = viewHeight * 0.25;
		for (i=0; i<rainSections.length; i++){
			selector = "#"+rainSections[i].triggerElement().getAttribute('id');
			rainSections[i].offset(rainOffset);
		}
	}	

}

// =====================================================================
// Video - Iframe Player
// =====================================================================
function initVideoIframe(){
	$('.iframeTrigger').click(function(event) {
		event.preventDefault();	
		var vimeoID = $(this).data('vimeo');
		var iframe = $('iframe',$(this).closest('section'));

	   var vimeoIframePlayer = new Vimeo.Player(iframe);
		vimeoIframePlayer.getVideoId().then(function(currentID){
			if (currentID == vimeoID){
				vimeoIframePlayer.play().catch(function(error){
				 	console.error(error);   
				 });
			} else {
				vimeoIframePlayer.loadVideo(vimeoID).then(function(){
				    vimeoIframePlayer.play().catch(function(error){
					 	console.error(error);   
					 });
				});				
			}
		});
	});
}

// =====================================================================
// Video - Modals Player
// =====================================================================
function initVideoModal(){
		
	$('.modalTrigger').click(function(event){
		event.preventDefault();	
		var vimeoID = $(this).data('vimeo');
		var modalWidth = $(this).data('width');
		var modalHeight = $(this).data('height');
		
		//Checks for Custom Video Sizes
		if (modalWidth !== undefined && modalHeight !== undefined){
			viewHeight = vhCheck().vh;
			var viewWidth = window.innerWidth-20;
			
			// Makes sure width will fit viewport
			if (modalWidth > viewWidth){
				modalHeight = (viewWidth * modalHeight) / modalWidth;
				modalWidth = viewWidth;
			}

			document.documentElement.style.setProperty('--modal-width',modalWidth+'px');
			document.documentElement.style.setProperty('--modal-height',modalHeight+'px');
			$('#modal').addClass('customSize');
		}
		
		vimeoModalPlayer = new Vimeo.Player($('#modal #video-player'),{id:vimeoID,controls:true});
		vimeoModalPlayer.loadVideo(vimeoID).then(function(){
		    openModal();
		    vimeoModalPlayer.play().catch(function(error){
			 	console.error(error);   
			 });
		});
	});

}

// =====================================================================
// Global Functions: Modal Open/Close, Window Lock/Unlock, Window Scroll
// =====================================================================
function openModal(){	
	
	// Locks the background window and opens modal
	lockWindow(function(){
		$('html').addClass('showModal');
	});

	// Close Modal Button Listener
	$('#modal .modal-box .close').unbind('click').click(function(event){
		event.preventDefault();
		closeModal();
	});	
}
function closeModal(){
	// Unlocks the background window and closes modal
	unlockWindow(function(){
		$('html').removeClass('showModal');

		// Stops video if enabled
		if (typeof vimeoModalPlayer != 'undefined'){
			vimeoModalPlayer.pause();
			vimeoModalPlayer.setCurrentTime(0);
		}
		
		// Removes custom size information
		setTimeout(function(){
			document.documentElement.style.setProperty('--modal-width','');
			document.documentElement.style.setProperty('--modal-height','');	
			$('#modal').removeClass('customSize');	
		}, 500);
	});
		
}
function lockWindow(callback){
	// Locks the background window
	var scrollPos = $(window).scrollTop();
	$('body').data('scrollPos',scrollPos);
	scrollPos = scrollPos * -1;
	$('html').addClass('noScroll').css('top',scrollPos+'px');	
	if(callback !== undefined){
		callback();
	}	
}
function unlockWindow(callback){
	// Unlocks the background window
	$('html').removeClass('noScroll').css('top','');
	$(window).scrollTop($('body').data('scrollPos'));
	if(callback !== undefined){
		callback();
	}
}
function scrollPage(scrollTo,callback){
	// Fixed Menu for Desktop & Mobile
	var scrollPos = 0;
	var scrollMenuHeight = 0;
	if ($(window).getBreakPoint() >= 1024){
		scrollMenuHeight = 50;
	} else {
		scrollMenuHeight = 60;
	}

	// Calculates Scroll Position
	if ($(scrollTo).length){
		if (scrollTo == "#top"){
			scrollPos = 0;
		} else {
			scrollPos = $(scrollTo).offset().top - scrollMenuHeight;
		}
	
		// Scroll down
		$('html, body').animate({
			scrollTop: scrollPos
		}, {duration: 500, easing: 'linear'}).promise().then(function(){
			if(callback !== undefined){
				callback();
			}
	   });
	} else {
		if(callback !== undefined){
			callback();
		}
	}	
}

// =====================================================================
// Global Function: ScrollTo Navigation
// =====================================================================
function initScrollMenu(){
		
	// Menu Item Click
	$('.scrollMenu').click(function(){
		event.preventDefault();
		if ($(window).getBreakPoint() <= 768){
			// Unlocks the background window
			unlockWindow(function(){
				$('html').removeClass('mobileNavOpen');
				$('header .hamburger').removeClass('open');
			});			
		} 
	
		// Scrolls to next point
		var attrHref = $(this).attr('href');
		var attrData = $(this).attr('data-href');
		
		if (typeof attrHref !== typeof undefined && attrHref !== false){
			scrollPage($(this).attr('href'));
		} else if (typeof attrData !== typeof undefined && attrData !== false){
			scrollPage($(this).attr('data-href'));
		}
		
	});	
}

// =====================================================================
// Global Function: watch for element in the DOM (10 sec max retry)
// =====================================================================
function elementReady(selector,callback,count){   
	if(!count){count=0;}
	if (document.querySelector(selector)){
		callback();
	} else {
		setTimeout(function(){
			if(count<=20) {
				count++;
				elementReady(selector,callback,count);
			} else {return;}
		}, 500);
	}
}

// ===================================================================
// Global Function: Tells what page is viewed based on body class/ID
// ===================================================================
function isPage(a){

	if($('body#'+a).length){return true;}
	else if ($('body').hasClass(a)){return true;}
	else if ($('body').hasClass('page-'+a)){return true;}
	else{return false;}

}

// ===================================================================
// Global Function: Triggers GTM Google Analytics
// ===================================================================
function pushGAEventLP(category,action,label){
	window.dataLayer.push({
		'event': 'Google Analytics - Event LP',
		'GAEvent_category': category,
		'GAEvent_action': action,
		'GAEvent_label': label,
		'GAEvent_page': '/mediasummit/',
		'GAEvent_title': 'Media Summit'
	});
}